import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/base/gould"

const gould = {
  getProvinceData() {
    return axios.post(pre + `/provinceData`, qs.stringify());
  },
  getCityData(keywords) {
    return axios.post(pre + `/cityData`, qs.stringify({keywords: keywords}));
  },
  getAreaData(keywords) {
    return axios.post(pre + `/areaData`, qs.stringify({keywords: keywords}));
  },
}
export default gould;



// WEBPACK FOOTER //
// ./src/api/base/gould/index.js